module.exports = __webpack_public_path__ + "static/media/freecodecamp-logo.443e2ec9.webp";